import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const ViewOnIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.3633 7.36398C14.566 7.64818 14.6673 7.79032 14.6673 8.00065C14.6673 8.21098 14.566 8.35312 14.3633 8.63732C13.4526 9.91438 11.1268 12.6673 8.00065 12.6673C4.8745 12.6673 2.54872 9.91438 1.63801 8.63732C1.43532 8.35312 1.33398 8.21098 1.33398 8.00065C1.33398 7.79032 1.43532 7.64818 1.63801 7.36398C2.54872 6.08694 4.8745 3.33398 8.00065 3.33398C11.1268 3.33398 13.4526 6.08694 14.3633 7.36398Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M10 8C10 6.8954 9.1046 6 8 6C6.8954 6 6 6.8954 6 8C6 9.1046 6.8954 10 8 10C9.1046 10 10 9.1046 10 8Z"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);
export const ViewOffIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.96 10.2933C13.5764 9.68145 14.0523 9.07338 14.3633 8.63732C14.566 8.35312 14.6673 8.21098 14.6673 8.00065C14.6673 7.79032 14.566 7.64818 14.3633 7.36398C13.4526 6.08694 11.1268 3.33398 8.00065 3.33398C7.39545 3.33398 6.82025 3.43716 6.2795 3.61283M4.49893 4.49893C3.15477 5.40545 2.16208 6.62909 1.63801 7.36398C1.43532 7.64818 1.33398 7.79032 1.33398 8.00065C1.33398 8.21098 1.43532 8.35312 1.63801 8.63732C2.54872 9.91438 4.8745 12.6673 8.00065 12.6673C9.32785 12.6673 10.5107 12.1711 11.5024 11.5024"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.57191 6.66602C6.21855 7.01935 6 7.50755 6 8.04675C6 9.12515 6.8742 9.99935 7.9526 9.99935C8.4918 9.99935 8.98 9.78082 9.33333 9.42742"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2 2L14 14"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
